// extracted by mini-css-extract-plugin
export default {"p":"f201c47e46 d2b949a7cc _8ca36fefd9","clr":"_0ca050e4c0","dls":"da9a33029a"};